import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type GalleryAssetCardBadgeProps = ComponentPropsWithoutRef<'div'>;

export const GalleryAssetCardBadge = memo(({ className, ...restProps }: GalleryAssetCardBadgeProps) => {
  return (
    <div
      className={cn('flex size-5 items-center justify-center rounded-8 bg-black/60 text-white', className)}
      {...restProps}
    ></div>
  );
});

GalleryAssetCardBadge.displayName = 'GalleryAssetCardBadge';
